import React from 'react';
import ChatWidget from './components/ChatWidget';
import './styles/App.css';

function App() {
  return (
    <div className="App">
      {/* Demo E-commerce Page */}
      <header className="app-header">
        <h1>E-commerce Store</h1>
        <p>Demo page with AI Chatbot</p>
      </header>

      <main className="app-main">
        <section className="hero-section">
          <h2>Welcome to Our Store</h2>
          <p>Need help? Click the chat button in the bottom right corner!</p>
        </section>

        <section className="features-section">
          <div className="feature-card">
            <h3>🤖 AI-Powered Chat</h3>
            <p>Get instant answers powered by ChatGPT</p>
          </div>
          <div className="feature-card">
            <h3>🛍️ Product Search</h3>
            <p>Find products from your WordPress store</p>
          </div>
          <div className="feature-card">
            <h3>📝 Contact Form</h3>
            <p>Can't find what you need? Submit a request</p>
          </div>
          <div className="feature-card">
            <h3>💾 Chat History</h3>
            <p>All conversations saved automatically</p>
          </div>
        </section>
      </main>

      {/* Chat Widget - Fixed at bottom right */}
      <ChatWidget />
    </div>
  );
}

export default App;
